import { get } from "jquery";
import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const coverageService = {
  getDeliveryCoverage: async (branch_id: string) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/coverageareas/delivery`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ branch_id }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch delivery coverage");
    }

    const json = await response.json();
    return json.data;
  },

  getOutboundCoverage: async (branch_id: string) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/coverageareas/outbound`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ branch_id }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch outbound coverage");
    }

    const json = await response.json();
    return json.data;
  },
};
